import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=2aeb7203&scoped=true&"
import script from "./ViewData.vue?vue&type=script&lang=js&"
export * from "./ViewData.vue?vue&type=script&lang=js&"
import style0 from "./ViewData.vue?vue&type=style&index=0&id=2aeb7203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb7203",
  null
  
)

export default component.exports